function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M256 512C114 512 0 398 0 256S114 0 256 0s256 114 256 256-114 256-256 256zm0-470C139 42 42 139 42 256s97 214 214 214 214-97 214-214S373 42 256 42zm0 347c-72 0-133-61-133-133s61-133 133-133 133 61 133 133-61 133-133 133zm0-226c-51 0-93 42-93 93s42 93 93 93 93-42 93-93-42-93-93-93zm-217-6l111 51-18 36-112-51zm96 120l18 36-111 51-19-36zm349-120l18 36-111 51-18-36zm-96 120l111 51-18 36-111-51zm-192 84l36 18-51 112-36-18zm120 0l51 112-36 18-51-112zM184 33l51 112-36 18-51-112zm144-12l36 18-51 112-36-18z"
})));